export default "__VITE_ASSET__rZcX2JYP__"